import React from "react";
import "./clientInfo.css";

export const ClientInfo = ({ setClientData}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setClientData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <div className="reservationBlock">
      <h2 className="reservationTitle"> Zadejte kontaktní údaje </h2>
      <div className="formWrapper">
        <div className="card">
          <h2>Jméno a příjmení</h2>
          <label className="input">
            <input
              className="input__field"
              type="text"
              placeholder=" "
              name="fullName"
              onChange={handleInputChange}
            />
          </label>
        </div>

        <div className="card">
          <h2>
              Email
          </h2>

          <label className="input">
            <input
              className="input__field"
              type="text"
              required={true}
              placeholder="@"
              name="email"
              onChange={handleInputChange}
            >
            </input>

          </label>

        </div>


        <div className="card">
          <h2>Telefonní číslo (+420)</h2>
          <label className="input">
            <input
              className="input__field"
              type="tel"
              placeholder="+420"
              name="phone"
              onChange={handleInputChange}
            />
          </label>
        </div>
      </div>
    </div>
  );
};
